import { Routes } from '@angular/router';
import { AuthGuard } from 'shared-library';
import { portalAccessGuard } from './core/guards/portal-access.guard';
import { InvestigatorLayoutComponent } from './layout/investigator-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: InvestigatorLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'queue',
        pathMatch: 'full',
      },
      {
        path: 'queue',
        canActivate: [AuthGuard, portalAccessGuard],
        loadComponent: () =>
          import('./pages/case-queue/case-queue.component').then(
            (module) => module.CaseQueueComponent
          ),
      },
      {
        path: 'dashboard',
        redirectTo: 'queue',
        pathMatch: 'full',
      },
      {
        path: 'queue/:id',
        canActivate: [AuthGuard, portalAccessGuard],
        loadComponent: () =>
          import('./pages/case-detail/case-detail.component').then(
            (module) => module.CaseDetailComponent
          ),
      },
      {
        path: 'reports',
        canActivate: [AuthGuard, portalAccessGuard],
        loadComponent: () =>
          import('./pages/reports/reports.component').then(
            (module) => module.ReportsComponent
          ),
      },
      {
        path: 'settings',
        canActivate: [AuthGuard, portalAccessGuard],
        loadComponent: () =>
          import('./pages/settings/settings.component').then(
            (module) => module.SettingsComponent
          ),
      },
      {
        path: 'case-table',
        redirectTo: 'queue',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'auth',
    loadChildren: () => import('shared-library').then((module) => module.AUTH_ROUTES),
  },
  {
    path: 'error',
    loadChildren: () => import('shared-library').then((module) => module.ERROR_ROUTES),
  },
  { path: '**', redirectTo: 'error/404' },
];
